<div *ngIf="IsVisible" class="info-text-wrapper">
    <h6 *ngIf="HasAdminrolle">Schlüssel: {{ infoContainer?.schluessel }}</h6>
    <div [innerHTMLBypassXSS]="beschreibungAsHtml"></div>
</div>
